import { render, staticRenderFns } from "./SettlementInfo.vue?vue&type=template&id=8e4fb5a4&"
import script from "./SettlementInfo.vue?vue&type=script&lang=js&"
export * from "./SettlementInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettlementInfo.vue?vue&type=style&index=0&id=8e4fb5a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports